export const ACCOUNTING_WORKFLOW = [
  { id: 'monitor', step: 1, label: 'Scan & findings', hint: 'Set period, run integrity scan, review issues one at a time' },
  { id: 'playbook', step: 2, label: 'Fix guide', hint: 'Step-by-step plain-language instructions from your last scan' },
  { id: 'tools', step: 3, label: 'Repair tools', hint: 'Specialist scripts and advanced fixes — loaded only when you open this tab' },
  { id: 'history', step: 4, label: 'Audit trail', hint: 'Every correction logged — who, when, why, and undo' },
];

export const DEFAULT_INTRO = {
  title: 'What does this screen do?',
  body: 'It checks whether this pump\'s books add up — like making sure your cash drawer, stock, and profit report all tell the same story.',
  how_to: [
    'Pick the date range you want to check.',
    'Click "Run integrity scan" (one check at a time).',
    'Review each problem using Next / Previous — fix one issue, then scan again.',
    'Use Fix guide or Repair tools only when you need a guided or batch fix.',
    'Every fix is saved in Audit trail with your reason.',
  ],
};

export const RISK_LABELS = { low: 'Low risk', medium: 'Medium risk', high: 'High risk — preview first' };
export const RISK_CLASS = { low: 'info', medium: 'warning', high: 'critical' };

export const CATEGORY_LABELS = {
  fuel_cogs: 'Fuel purchase & sales costs',
  opening_balance: 'Starting balances',
  stock: 'Shop / lubricant stock',
  gas_cylinder: 'Gas cylinders',
  owners_fund: 'Owners Fund statement',
  ledger: 'Main books',
  cash: 'Cash & collections',
  other: 'Other fixes',
};

export const STANDALONE_WIZARD_KEY = '__standalone__';

export function severityClass(severity) {
  if (severity === 'critical') return 'critical';
  if (severity === 'warning') return 'warning';
  return 'info';
}

export function formatMoney(v) {
  if (v == null || Number.isNaN(Number(v))) return '—';
  return `₹${Number(v).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function flattenFindings(sections = []) {
  const items = [];
  sections.forEach((section) => {
    (section.findings || []).forEach((finding) => {
      items.push({
        sectionId: section.id,
        sectionLabel: section.label,
        finding,
        key: `${finding.finding_type}-${finding.entity_id || finding.title}`,
      });
    });
  });
  return items;
}
